//
import { mapActions } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"

//
import QueryModel from "@/models/General/GQuery"

//
import filters from "./filters"
import headers from "./headers"

//
export default {
    name: "query-list",
    components: {
        ModelDataTable,
    },
    computed: {

        /**
         *
         */
        tableProps () {
            return {
                service: QueryModel,
                filters,
                headers,
                mapper: row => row.reset()
            }
        },
    },
    data () {
        return {
            selected: null,
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
            setItemsTopBar: "setItemsTopBar",
        }),

        /**
         * 
         */
        delete () {
            this.selected.toDelete().delete().then( this.successDelete ).then( this.$refs.table.refresh ).catch( this.errorDelete ); 
        },

        /**
         *
         */
        errorDelete ( error ) {
            this.$toast.error( error.message )
        },

        /**
         *
         */
        submitCreate () {
            this.$router.push({ name: "query-create" })
        },

        /**
         *
         */
        submitDelete ( event ) {
            this.selected = event.item
            this.$toast.confirm( "¿Confirma la eliminación de la consulta seleccionada?", this.$toaster( this, this.delete ) )
        },
        
        /**
         *
         */
        submitRun ( event ) {
            this.$router.push({ name: "query-run", params: { id: event.item.id } })
        },

        /**
         *
         */
        submitUpdate ( event ) {
            this.$router.push({ name: "query-update", params: { id: event.item.id } })
        },

        /**
         * 
         */
        successDelete () {
            this.$toast.success( "Consulta eliminada exitosamente." )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Consultas" )
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: "accent",
                icon: "add_circle",
                text: "crear consulta",
                tip: "Crear nueva consulta",
            }
        ])
    },
}